import React, { createContext, useContext, useEffect, useRef } from 'react';
import { socketService } from '../services/socket';
import { storage } from '../utils/storage';

const SocketContext = createContext(socketService);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const socketRef = useRef(socketService);
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) return;
    isInitialized.current = true;

    socketRef.current.connect();

    const token = storage.getToken();
    const user = storage.getUser();

    if (token && user) {
      console.log('SocketProvider: Найден токен, авторизуем сокет');

      const socket = socketRef.current.getSocket();
      if (socket) {
        if (socket.connected) {
          socketRef.current.authenticate(user.id, user.userNumber);
        } else {
          socket.once('connect', () => {
            console.log('SocketProvider: Сокет подключен, авторизуемся');
            socketRef.current.authenticate(user.id, user.userNumber);
          });
        }
      }
    }

    return () => {
      socketRef.current.disconnect();
    };
  }, []);

  return <SocketContext.Provider value={socketRef.current}>{children}</SocketContext.Provider>;
};

export const useSocketContext = () => {
  return useContext(SocketContext);
};
